import _cloneDeep from 'lodash/cloneDeep';

import AddNoteDialogController from './dialog/add-note/add-note.controller';

import EditNoteDialogController from './dialog/edit-note/edit-note.controller';

const AddNoteTemplate = require('./dialog/add-note/add-note.html');

const EditNoteTemplate = require('./dialog/edit-note/edit-note.html');

export default class NotesController {
    /** @ngInject */
    constructor(NotesApi, $q, DialogService, ToastService, Loader) {
        this.$q = $q;
        this.NotesApi = NotesApi;
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.Loader = Loader;
    }

    $onInit() {
        this.limit = 100;
        this.pageToken = '';
        this.getNotes();
    }

    $onChanges(changes) {
        if (changes.reset && changes.reset.currentValue === 'reset') {
            this.notes = _cloneDeep(this.clonedNotes);
        }

        if (changes.thingId && changes.thingId.currentValue) {
            this.pageToken = '';
            this.getNotes();
        }
    }

    getNotes() {
        const config = {
            object_id: this.thingId,
            page_size: this.limit,
            page_token: this.pageToken
        };

        this.NotesApi.getListByObject(config)
            .then((data) => {
                this.notes = data.notes || [];
                this.clonedNotes = _cloneDeep(this.notes);
                this.pageToken = data.next_page_token;
            }, () => {
                this.notes = [];
            });
    }

    removeNote(index, noteId) {
        this.Loader.show();

        this.NotesApi.deleteNote(noteId)
            .then(() => {
                this.notes.splice(index, 1);
                this.Loader.hide();
                this.ToastService.showSimpleTranslated('comment_was_removed');
            });
    }

    addNoteDialog($event) {
        this.DialogService.show({
            controller: AddNoteDialogController,
            controllerAs: '$ctrl',
            template: AddNoteTemplate,
            parent: document.body,
            targetEvent: $event,
            openFrom: 'top',
            closeTo: 'top',
            clickOutsideToClose: true,
            escapeToClose: true,
            fullscreen: true,
            locals: {
                thingId: this.thingId,
                notes: this.notes
            }
        });
    }

    editNoteDialog($event, note) {
        this.DialogService.show({
            controller: EditNoteDialogController,
            controllerAs: '$ctrl',
            template: EditNoteTemplate,
            parent: document.body,
            targetEvent: $event,
            openFrom: 'top',
            closeTo: 'top',
            clickOutsideToClose: true,
            escapeToClose: true,
            fullscreen: true,
            locals: {
                note
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/notes/notes.controller.js